export default "__VITE_ASSET__a913090a__"